<template>
  <div class="detail-page-return">
    <div class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>客户回访</div>
    </div>

    <div class="content-box">
      <van-cell-group>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>用户名</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div class="field__control">{{info.realname}}</div>
            </div>
          </div>
        </div>

        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>手机号</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div class="field__control">{{info.phone}}</div>
            </div>
          </div>
        </div>

        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>简介</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.simple}}</div>
            </div>
          </div>
        </div>

        <van-field
          @click="typeShow=true"
          v-model="typeLabel"
          required
          label="类型"
          readonly="readonly"
          placeholder="请选择类型"
        />
        <van-popup :style="{width:'100%'}" position="bottom" v-model="typeShow">
          <van-picker :default-index="deIndex" :columns="selectList" @change="onChange" />
        </van-popup>

        <van-field
          v-model="reason"
          v-if="type==-1"
          type="phone"
          label="拒绝理由"
          placeholder="请输入拒绝理由"
          required
        />

        <van-field v-model="info.real" type="text" label="真实职业" placeholder="请输入" />
        <van-field v-model="info.intention" type="text" label="意向程度" placeholder="请输入" />
        <van-field v-model="info.channel" type="text" label="了解活动途径" placeholder="请输入" />
        <van-field v-model="info.company" type="text" label="工作单位" placeholder="请输入" />
        <van-field v-model="info.notes" type="text" label="其他注释" placeholder="请输入" />
      </van-cell-group>

      <div class="submit" @click="addData">提交</div>
    </div>
  </div>
</template>


// token	是	string	用户标示
// id	是	string	客户id 146接口返回

// status	是	int	审核状态 状态-1报名已拒绝 0待分配客服 1客服待跟进 2 1审通过 3 2审通过 4 3审通过	样式为html 为select 下拉框形式
// reason	拒绝理由	是	string	拒绝理由	当status 为-1是 这里必填
// real	是	string	真实职业	客服可以不填 不填传空
// intention	是	string	意向程度	客服可以传不填 默认传空
// channel	是	string	了解活动途径	客服可以传不填 默认传空
// company	是	string	工作单位	客服可以传不填 默认传空
// notes	是	string	其他注释	客服可以传不填 默认传空

// works	否	string	作品地址 七牛云上传后的	作品地址 默认传原值
// worksname	否	string	作品名称	作品名称 默认传原值
// img	否	string	作品图片	客服可以传不填 默认传原值
// introduction 否	string	作品简介	作品简介 默认传原值

<script>
import province_list from "@/assets/js/dq.js";

export default {
  name: "detail",
  data() {
    return {
      type: "",
      info: {
        reason: "", //拒绝理由
        real: "", //真实职业
        intention: "", //意向
        channel: "",
        company: "",
        notes: "",
      },
      typeLabel: "",
      typeShow: false,
      deIndex: 0,
      selectList: [
        {
          text: "报名已拒绝",
          value: -1,
        },
        {
          text: "待分配客服",
          value: 0,
        },
        {
          text: "客服待跟进",
          value: 1,
        },
        {
          text: "审通过",
          value: 2,
        },
      ],

      postKey: true,
    };
  },
  mounted() {
    let item = this.$route.query.item;
    item = JSON.parse(item || "{}") || {};
    this.info = {       
        reason: "", //拒绝理由
        real: "", //真实职业
        intention: "", //意向
        channel: "",
        company: "",
        notes: "",
        ...item};
    let status = +item.status;
    this.typeLabel = this.selectList[status + 1].text;
    this.deIndex = status + 1;
    this.type = status;
  },
  methods: {
    addData() {
      if (this.postKey) {
        let token = window.localStorage.getItem("token");
        if (this.type == -1 && !this.info.reason) {
          this.$toast("请输入拒绝理由");
          return;
        }
        let obj = {
          token,
          id: this.info.id,
          status: this.type,
          reason: this.info.reason, //拒绝理由
          real: this.info.real, //真实职业
          intention: this.info.intention, //意向
          channel: this.info.channel,
          company: this.info.company,
          notes: this.info.notes,

          works:this.info.works,
          worksname:this.info.worksname,
          img:this.info.img,
          introduction:this.info.introduction,
        };

        this.postKey = false;
        this.$http.post("huawuupdate", obj).then(
          (res) => {
            this.postKey = true;
            this.$toast(res.data.msg || "系统错误");
            if (res && res.data && res.data.code === 200) {
              setTimeout(() => {
                this.$router.go(-1);
              }, 2000);
            } else {
            }
          },
          (e) => {
            this.postKey = true;
            this.$toast("网络错误");
          }
        );
      }
    },

    onClickLeft() {
      this.$router.go(-1);
    },

    onChange(picker, value, index) {
      this.typeLabel = value.text;
      this.type = value.value;
    },
  },
};
</script>

<style lang="scss">
#app {
  background: #eeeeee;
}

.detail-page-return {
  height: 100%;

  &.blurbg {
    background: #057cff;
  }

  .jump-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    background: rgba(0, 0, 0, 0.6);
    align-items: center;
    justify-content: center;

    .jump-clr {
      background: #ffffff;
      width: 3.8rem;
      height: 1.8rem;
      align-items: center;
      justify-content: center;
      display: flex;
      border-radius: 0.08rem;
      font-size: 0.32rem;
      text-align: center;
      color: #333;
      position: relative;
      padding-bottom: 0.88rem;
      line-height: 1.4;

      .jump-remove {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #f4f4f4;
        height: 0.88rem;
        text-align: center;
        color: #666666;
      }
    }
  }

  .detail-page {
    .submit {
      margin-top: 1rem;
      height: 0.75rem;
      background: rgba(127, 207, 241, 1);
      font-size: 0.28rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }

  .out-top {
    text-align: center;
    line-height: 0.98rem;
  }

  .top-bg-st {
    position: relative;
    height: 2.4rem;
    width: 7.5rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
  }

  .content-box {
    position: fixed;
    background: #ffffff;
    top: 1.24rem;
    width: 6.86rem;
    padding-bottom: 1.6rem;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: 0 auto;
    border-radius: 0.32rem;
    padding-top: 0.32rem;
    color: #999999;
  }

  .wb-content {
    padding-bottom: 0.24rem;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding-top: 0.32rem;
    color: #999999;
    background: #057cff;

    .wb-logo {
      padding-top: 0.3rem 0 0.55rem;
      margin: 0 auto;
      width: 3.4rem;
      height: auto;
      display: block;
    }

    .wb-text {
      display: block;
      margin: 0 auto;
      width: 4.8rem;
      height: auto;
      padding-bottom: 0.6rem;
    }

    .van-cell-group {
      background: #057cff;
      color: #fff;

      .van-cell {
        background: #057cff;
        color: #fff;

        input {
          background: #057cff;
          color: #fff;
        }
      }
    }

    input::input-placeholder {
      color: #ffffff !important;
    }

    input::-webkit-input-placeholder {
      color: #ffffff !important;
    }

      input:-moz-placeholder {
      color: #ffffff !important;
    }

      input::-moz-placeholder {
      color: #ffffff !important;
    }

      input:-ms-input-placeholder {
      color: #ffffff !important;
    }

    .wb-submit {
      margin: 0.55rem auto 0.34rem;
      width: 5.5rem;
      height: 0.8rem;
      background-image: linear-gradient(to right, #ffc200, #ff5900);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.4rem;
    }

    .has-zh {
      line-height: 1;
      font-size: 0.32rem;
      color: #ffffff;
      text-align: center;
      height: 2.8rem;
      background: url("https://qn.xwyyjt.com/ht_kh_yq_bg.png") no-repeat 0
        0.2rem;
      background-size: 60%;
    }
  }

  .wb-form {
    padding: 0 1rem;
  }

  .van-cell,
  .van-cell__value,
  .van-field__control {
    color: #999999;
  }

  .btn-blur {
    border-radius: 0.12rem;
    margin-top: 0.12rem;
    padding: 0.12rem 0.32rem;
    border-right: 0.32rem;
    width: 1.6rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
    color: #ffffff;
  }

  .submit {
    margin: 0.42rem auto 0;
    width: 4rem;
    height: 0.72rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  [class*="van-hairline"]::after {
    border: none;
  }
  .van-cell:last-child::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/returnDetail.vue